// Email handler for <request-a-quote>

const PENDING_KEY = 'hbno_rfq_pending';

document.addEventListener('request-a-quote:submitted', async (e) => {
  const { form, context } = e.detail;

  if (!form) {
    document.dispatchEvent(
      new CustomEvent('request-a-quote:error', {
        detail: { message: 'Form not initialized. Please refresh and try again.' },
      }),
    );
    return;
  }

  const fd = new FormData(form);
  const action = form.getAttribute('action') || '/contact';

  try {
    const response = await fetch(action, {
      method: 'POST',
      headers: { Accept: 'text/html' },
      body: fd,
    });

    // Shopify redirected to a captcha challenge — save state and hand off to the browser.
    // After the user solves it, Shopify returns to the original page with ?contact_posted=true,
    // where the component picks up the saved context and shows the success state.
    if (response.url && response.url.indexOf('/challenge') !== -1) {
      try {
        sessionStorage.setItem(PENDING_KEY, JSON.stringify({ context: context || {} }));
      } catch (_) {}
      const rfq = document.querySelector('request-a-quote');
      if (rfq && typeof rfq.showLoading === 'function') rfq.showLoading();
      window.location.href = response.url;
      return;
    }

    if (response.ok) {
      document.dispatchEvent(new CustomEvent('request-a-quote:success'));
      return;
    }

    // 400 here means Shopify wants a captcha token we didn't have on this fetch attempt.
    // Shopify's captcha-bootstrap is concurrently running its own native form submission
    if (response.status === 400) {
      const rfq = document.querySelector('request-a-quote');
      if (rfq && typeof rfq.showLoading === 'function') rfq.showLoading();
      setTimeout(() => {
        document.dispatchEvent(
          new CustomEvent('request-a-quote:error', {
            detail: { message: 'Submission is taking longer than expected. Please try again.' },
          }),
        );
      }, 15000);
      return;
    }

    document.dispatchEvent(
      new CustomEvent('request-a-quote:error', {
        detail: { message: `Submission failed (${response.status}). Please try again.` },
      }),
    );
  } catch (err) {
    document.dispatchEvent(
      new CustomEvent('request-a-quote:error', {
        detail: { message: 'Network error. Please check your connection and try again.' },
      }),
    );
  }
});
